import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the EthemeProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
export interface theme {
  gradientstart;
  gradientend;
  logo;
  invertlogo;
  colortext;
  strokecolor;
  ictxcolorverticalbar;
  bgsize;
  bgurl;
  bgcolor;
}

@Injectable()
export class EthemeProvider {

  config_eydlab: theme = {
    gradientstart: '#cc3434',
    gradientend: '#d6e000',
    logo: 'assets/icon/eydlab_logo.svg',
    invertlogo: 'assets/icon/eydlab_logo.svg',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern.png\')',
    bgcolor: '#191921',
  };
  config_safe = {
    gradientstart: '#8cc63f',
    gradientend: '#9eefe5',
    logo: 'assets/icon/safe_logo.svg',
    invertlogo: 'assets/icon/safe_logo.svg',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern.png\')',
    bgcolor: '#021128',
  }
  config_clerici = {
    gradientstart: '#8cc63f',
    gradientend: '#9eefe5',
    logo: 'assets/icon/clerici.svg',
    invertlogo: 'assets/icon/clerici.svg',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern.png\')',
    bgcolor: '#021128',
  }
  config_ilportico = {
    gradientstart: '#D34018',
    gradientend: '#6ebeca',
    logo: 'assets/icon/ilportico.png',
    invertlogo: 'assets/icon/ilportico.png',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern.png\')',
    bgcolor: '#021128',
  }
  config_eydlab_vecchio = {
    gradientstart: '#8cc63f',
    gradientend: '#9eefe5',
    logo: 'assets/icon/eydlab_logo.svg',
    invertlogo: 'assets/icon/eydlab_logo_black.svg',
    colortext: '#000000',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'../assets/image/bg_eydlab_vecchio.jpg\')',
    bgcolor: '#ffffff',
  }
  config_trivio = {
    gradientstart: '#06315e',
    gradientend: '#9eefe5',
    logo: 'assets/icon/eydlab_logo.svg',
    invertlogo: 'assets/icon/eydlab_logo_black.svg',
    colortext: '#000000',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'../assets/image/bg_trivio.png\')',
    bgcolor: '#ffffff',
  }
  config_eydlab_light = {
    gradientstart: '#c10108',
    gradientend: '#740c10',
    logo: 'assets/icon/eydlab_logo_black.svg',
    invertlogo: 'assets/icon/eydlab_logo_black.svg',
    // logo: 'assets/icon/bbhotel.png',
    // invertlogo: 'assets/icon/bbhotel.png',
    colortext: '#000000',
    strokecolor: '#cbcbcb',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern_havana.svg\')',
    bgcolor: '#ffffff',
  }
  config_primachemical = {
    gradientstart: '#c10108',
    gradientend: '#740c10',
    logo: 'assets/icon/primachemical.png',
    invertlogo: 'assets/icon/primachemical.png',
    // logo: 'assets/icon/bbhotel.png',
    // invertlogo: 'assets/icon/bbhotel.png',
    colortext: '#000000',
    strokecolor: '#cbcbcb',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern_havana.svg\')',
    bgcolor: '#ffffff',
  }
  config_eydlab_ejoy = {
    gradientstart: '#BEE500', 
    gradientend: '#BEE500',
    // logo: 'assets/icon/eydlab_logo_black.svg',
    // invertlogo: 'assets/icon/eydlab_logo_black.svg',
    // logo: 'assets/icon/bbhotel.png',
    // invertlogo: 'assets/icon/bbhotel.png',
    logo: 'assets/icon/ejoy_new.png',
    invertlogo: 'assets/icon/ejoy_new.png',
    colortext: '#000000', 
    strokecolor: '#cbcbcb',
    ictxcolorverticalbar: '#333333',
    bgsize: '200px',
    bgurl: 'url(\'\')',
    bgcolor: '#ECEBE9',
  }
  config_coldiretti = {
    gradientstart: '#00904A',
    gradientend: '#FFEC00',
    logo: 'assets/icon/logo_coldiretti_dash.png',
    invertlogo: 'assets/icon/logo_coldiretti_login.png',
    colortext: '#000000',
    strokecolor: '#C6C6C6',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#FFED00',
  }
  config_noeinglese = {
    gradientstart: '#FF893E',
    gradientend: '#B9DB01',
    logo: 'assets/icon/logonoe.png',
    invertlogo: 'assets/icon/login_noe_.png',
    colortext: '#000000',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#E6E5E3',
  }
  config_ai = {
    gradientstart: '#FF893E',
    gradientend: '#B9DB01',
    logo: 'assets/icon/logoai.png',
    invertlogo: 'assets/icon/login_ai_.png',
    colortext: '#000000',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#E6E5E3',
  }
  config_coachfit: theme = {
    gradientstart: '#EB1E65',
    gradientend: '#5BBBD7',
    logo: 'assets/icon/logo_fit.svg',
    invertlogo: 'assets/icon/logo_fit_login.svg',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: 'cover',
    bgurl: 'url(\'../assets/image/bg_fit.jpg\')',
    bgcolor: '#2b3a5e',
  };
  config_bullappami: theme = {
    gradientstart: '#FA2257',
    gradientend: '#2CA5CC',
    logo: 'assets/icon/logo_bullappami.png',
    invertlogo: 'assets/icon/logo_bullappami.png',
    colortext: '#ffffff',
    strokecolor: '#ffffff',
    ictxcolorverticalbar: '#ffffff',
    bgsize: 'cover',
    bgurl: 'url(\'../assets/image/bg_bullappami.png\')',
    bgcolor: '#2b3a5e',
    // --bg-first-color-button:#FA2257;
    // --bg-second-color-button:#2CA5CC;
  };
  config_galderma = {
    gradientstart: '#8cc63f',
    gradientend: '#9eefe5',
    logo: 'assets/icon/galderma_w.png',
    invertlogo: 'assets/icon/galderma.png',
    colortext: '#000000',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#61bcce',
  };
  config_viceversa: theme = {
    gradientstart: '#cc3434',
    gradientend: '#d6e000',
    logo: 'assets/icon/viceversa.png',
    invertlogo: 'assets/icon/viceversa.png',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern.png\')',
    bgcolor: '#191921',
  };
  config_withub: theme = {
    gradientstart: '#cc3434',
    gradientend: '#d6e000',
    logo: 'assets/icon/withub.png',
    invertlogo: 'assets/icon/withub.png',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern.png\')',
    bgcolor: '#191921',
  };
  config_demo: theme = {
    gradientstart: '#cc3434',
    gradientend: '#d6e000',
    logo: '',
    invertlogo: '',
    colortext: '#ffffff',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#ffffff',
    bgsize: '200px',
    bgurl: 'url(\'../assets/image/bg_pattern.png\')',
    bgcolor: '#191921',
  };
  config_yamamay: theme = {
    gradientstart: '#781421',
    gradientend: '#E25476',
    logo: 'assets/icon/yamamay_loginx.svg',
    invertlogo: 'assets/icon/yamamay_loginx.svg',
    colortext: '#CB1938',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#CB1938',
  };
  config_sky: theme = {
    gradientstart: '#EF29AA',
    gradientend: '#F16205',
    logo: 'assets/icon/sky_logo.svg',
    invertlogo: 'assets/icon/sky_logo.svg',
    colortext: '#494949',
    strokecolor: '#9B9B9B',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#F2F2F3',
  };
  config_mygame: theme = {
    gradientstart: '#F8B018',
    gradientend: '#CF4B16',
    logo: 'assets/icon/mygame_title.svg',
    invertlogo: 'assets/icon/mygamesvg.svg',
    colortext: '#494949',
    strokecolor: '#9B9B9B',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#F2F2F3',
  };
  config_privacygoal: theme = {
    gradientstart: '#203C89',
    gradientend: '#5490CC',
    logo: 'assets/icon/privacygoal_loginx_invert.svg',
    invertlogo: 'assets/icon/privacygoal_loginx.svg',
    colortext: '#203C89',
    strokecolor: '#4b4b50',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#203C89',
  };
  config_carrefour = {
    gradientstart: '#1D3666',
    gradientend: '#5282B3',
    logo: 'assets/icon/invert_logo_carrefourx.png',
    invertlogo: 'assets/icon/logo-carrefourx.png',
    colortext: '#000000',
    strokecolor: '#A8A8A8',
    ictxcolorverticalbar: '#000000',
    bgsize: 'cover',
    bgurl: 'url(\'\')',
    bgcolor: '#E6E5E3',
  }
  c: theme;// = this.config_eydlab; 
  theme_selected: string = 'dark-theme_';

  constructor() {
    //console.log('Hello EthemeProvider Provider');

  }
  set_bg_style() {
    var appx = document.querySelector('ion-app');
    // appx.classList.add('bg_wall');
    appx.setAttribute('style', 'background-color:' + this.c.bgcolor + ' !important;\
     background-image:'+ this.c.bgurl + ' !important; \
     background-repeat:repeat; \
     background-size:'+ this.c.bgsize + ';\
     color: '+ this.c.colortext + ' !important;')
    // var modalx = document.querySelector('ion-modal');
    // appx.classList.add('bg_wall');
    // modalx.setAttribute('style', 'width:100%;height:100%;background-color:' + this.c.bgcolor + ' !important;\
    //  background-image:'+ this.c.bgurl + ' !important; \
    //  background-repeat:repeat; \
    //  background-size:'+ this.c.bgsize + ';\
    //  color: '+ this.c.colortext + ' !important;');


  }
  set_config_theme(themename) {

    switch (themename) {
      case 'dark-theme_':
        this.c = this.config_eydlab;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'eydlab-theme':
        this.c = this.config_eydlab_vecchio;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'safe-theme':
        this.c = this.config_safe;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'havana-theme':
        this.c = this.config_eydlab_light;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'ejoy-theme':
        this.c = this.config_eydlab_ejoy;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'noeinglese-theme':
        this.c = this.config_noeinglese;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'coachfit-theme':
        this.c = this.config_coachfit;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'galderma-theme':
        this.c = this.config_galderma;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'viceversa-theme':
        this.c = this.config_viceversa;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'withub-theme':
        this.c = this.config_withub;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'demo-theme':
        this.c = this.config_demo;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'coldiretti-theme':
        this.c = this.config_coldiretti;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'primachemical-theme':
        this.c = this.config_primachemical;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'yamamay-theme':
        this.c = this.config_yamamay;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'bullappami-theme':
        this.c = this.config_bullappami;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'sky-theme':
        this.c = this.config_sky;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'mygame-theme':
        this.c = this.config_mygame;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'privacygoal-theme':
        this.c = this.config_privacygoal;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'trivio-theme':
        this.c = this.config_trivio;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'carrefour-theme':
        this.c = this.config_carrefour;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'ilportico-theme':
        this.c = this.config_ilportico;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'clerici-theme':
        this.c = this.config_clerici;
        this.theme_selected = themename;
        this.set_bg_style();
        break;
      case 'ai-theme':
        this.c = this.config_ai;
        this.theme_selected = themename;
        this.set_bg_style();
        break;

    }

  }

}



// WEBPACK FOOTER //
// ./src/providers/etheme/etheme.ts